<template>
  <div class="customer-list-wrapper">
    <div class="row">
      <div class="col-md-12 d-flex align-items-center">
        <span class="fw-500 fs-16">Select Filter</span>
        <span @click="openAdvancedFilterModal()" class="fw-500 fs-16 text-primary ml-10 make-cursor-pointer"><i class="fa fa-filter mr-10"></i>Advanced Filter</span>
        <span v-if="advancedFilter.flag && advancedFilter.jobType" class="badge badge-pill badge-primary ml-5 mb-0">JobType: {{ advancedFilter.jobType }}</span>
        <span v-if="advancedFilter.flag && advancedFilter.searchQuery" class="badge badge-pill badge-primary mb-0 ml-5">Search By: {{ advancedFilter.searchQuery }}</span>
        <span v-if="advancedFilter.flag" @click="resetAdvancedFilter()"> <i class="fa fa-times-circle ml-5 text-primary"></i></span>
      </div>
      <div class="col-md-4 mt-10">
        <div class="form-group">
          <label class="">Search By</label>
          <select class="form-control pt-5 pb-5 pl-5 pr-5" v-model="searchBy">
            <option value="" disabled selected>Select Search By</option>
            <option v-for="(search, index) in searchByFilter" :value="search.value" v-bind:key="index"> {{ search.name }}</option>
          </select>
        </div>
      </div>
      <div v-if="searchBy !== 'loginAttempts'" class="col-md-4 mt-9">
        <div class="form-group">
          <label for="">Domain / IP / Status / JobType / Job ID</label>
          <select v-if="searchBy === 'status'" class="form-control pt-5 pb-5 pl-5 pr-5" v-model="searchQuery">
            <option value="" disabled selected>Select {{searchBy}}</option>
            <option v-for="(search, index) in statusArray" :value="search.value" v-bind:key="index"> {{ search.name }}</option>
          </select>
          <select v-else-if="searchBy === 'jobType'" class="form-control pt-5 pb-5 pl-5 pr-5" v-model="searchQuery">
            <option value="" disabled selected>Select {{searchBy}}</option>
            <option v-for="(search, index) in jobTypeArray" :value="search.value" v-bind:key="index"> {{ search.name }}</option>
          </select>
          <input v-else @keyup.enter="fetchJobs" v-model="searchQuery" type="text" class="form-control mt-2" :placeholder="`${searchBy === 'loginAttempts' ? 'Failed Login Attempts' : (searchBy === 'inputDomain' ? 'Enter domain' : (searchBy === 'jobLogId' ? 'Enter Job ID' : `Enter ${searchBy.toUpperCase()}`))}`" />
        </div>
      </div>
      <div class="col-md-4 pl-0 mt-23 d-flex justify-content-between align-items-center">
        <div>
          <button class="btn btn-primary" v-on:click="fetchJobs" :disabled="loading">
            Search
          </button>
          <button class="btn btn-pink ml-10" v-on:click="refreshLogs('refresh')" :disabled="loading">
            Refresh
          </button>
        </div>
        <div>
          <span>
            Total Running Jobs:
            <span class="badge badge-pill badge-success">{{ runningJobs }}</span>
          </span>
            <br>
            <span>
            Awaiting Hook Jobs:
            <span class="badge badge-pill badge-danger">{{ awaitingHookJobs }}</span>
          </span>
        </div>
      </div>
      <div class="customer-list-info col-md-12 has-text-centered" v-if="(logs.length === 0 && noLogs === false) || !asyncDone">
        <div class="loader">
          <h3 style="position: relative;top: 125px;width: 500px;left: -80px;">{{asyncText}}</h3>
        </div>
      </div>
      <div v-if="noLogs && asyncDone" class="customer-list-info">
        <p class="card-text text-center text-danger mb-3 font-weight-bold">There are no
          logs in the database to show here.</p>
      </div>
      <div v-else-if="logs.length > 0" class="col-md-12 mt-10 table-responsive-md">
        <table class="table table-responsive table-bordered">
          <thead class="light">
          <th>Job ID</th>
          <th>Job Type</th>
          <th>Initiated By</th>
          <th>Server IP</th>
          <th>Requester IP</th>
          <th>Input Domain</th>
          <th class="text-center">Status</th>
          <th>Created At</th>
          <th>Completed At</th>
          <th>Action</th>
          </thead>
          <tbody >
          <tr v-for="(log, index) in logs" :key="index">
            <td width="14%">{{ log.docID }}</td>
            <td width="10%">{{ log.jobName }}</td>
            <td class="make-cursor-pointer" v-if="log.collaborator">
              <span data-toggle="tooltip" data-placement="top" data-html="true" title="Collaborator">
                {{ log.collaboratorName }}
              </span>
            </td>
            <td v-else class="make-cursor-pointer">
              <span data-toggle="tooltip" data-placement="top" data-html="true" :title="log.jobData && log.jobData.operatingUser && log.jobData.operatingUser.initiatedBy === 'Admin' ? 'Admin' : 'Client'">
                {{ log.jobData && log.jobData.operatingUser && log.jobData.operatingUser.initiatedBy === 'Admin' ? log.jobData.operatingUser.fullName : log.user.firstName + ' ' + log.user.lastName }}
              </span>
            </td>
            <td  class="make-cursor-pointer" @click="doCopy(log.jobData.ip)">{{log.jobData ? log.jobData.ip || 'N/A' : 'N/A'}}</td>

            <td  width="13%" v-if="log.jobName === 'too-many-login-requests'" class="make-cursor-pointer" @click="doCopy(log.jobData.location.ip)">{{log.jobData ? log.jobData.location ? log.jobData.location.ip  || 'N/A' : 'N/A' : 'N/A'}}</td>
            <td v-else width="13%" class="make-cursor-pointer" style="word-break: break-all"  @click="doCopy(log.jobData.operatingUser.ip)">{{log.jobData ?  log.jobData.operatingUser ?  log.jobData.operatingUser.ip ? log.jobData.operatingUser.ip : 'N/A' : 'N/A' : 'N/A'}}</td>

            <td v-if="log.jobName === 'too-many-login-requests'" class="make-cursor-pointer"><span data-toggle="tooltip" data-placement="top" data-html="true" :title="log.jobData.email">{{ log.jobData.email || 'N/AA' }}</span></td>
            <td v-else class="make-cursor-pointer"><span data-toggle="tooltip" data-placement="top" data-html="true" :title="log.jobData && log.jobData.isPrimary ? 'Primary' : 'Addon'">{{ log.inputDomain }}</span></td>
            <td class="text-center">
              <span class="badge badge-pill badge-success" v-if="log.status === 'complete' && log.progress === 'success'">Completed</span>
              <span class="badge badge-pill badge-danger" v-else-if="log.status === 'complete' && log.progress === 'error'">Error</span>
              <span class="badge badge-pill badge-danger" v-else-if="log.status === 'stop' && log.progress === 'error'">Stopped</span>
              <span class="badge badge-pill badge-warning" v-else-if="log.status === 'Pending'">Pending</span>
              <span class="badge badge-pill badge-warning" v-else-if="log.status === 'paused'">Paused</span>
              <span class="badge badge-pill badge-warning" v-else-if="log.status === 'awaiting-hook'" data-toggle="tooltip" data-placement="top" data-html="true" title="Awaiting Hook">Running <i class="fa fa-hourglass-start"/></span>
              <span class="badge badge-pill badge-default" v-else>Running</span>
            </td>
            <td width="13%">{{ formatDate(log.createdAt) }}</td>
            <td width="15%"><span v-if="log.completedAt">{{ formatDate(log.completedAt) }}</span></td>
            <td width="10%" class="text-center">
              <div style="display: flex">
                <button data-toggle="tooltip" data-placement="top" data-html="true" title="View Logs" class="btn btn-primary btn-sm mr-2" @click="viewLogs(log)"><i class="fa fa-eye"></i></button>
                <button v-if="log.jobName === 'too-many-login-requests'" data-toggle="tooltip" data-placement="top" data-html="true" title="Refresh Account Access" :disabled="refreshLoader" class="btn btn-primary btn-sm mr-2" @click="refreshAccountAccess(log)"><i class="fa fa-refresh"></i></button>
                <button v-if="log.jobName === 'CHECK-SERVER-CRON'" title="Retry Now" data-toggle="tooltip" data-placement="top" data-html="true" :disabled="retryLoader === log.docID" class="btn btn-success btn-sm mr-2" @click="retryCheckServer(log)"><i class="fa fa-refresh"></i></button>
                <button v-if="(user.email === 'sara@bigscoots.com') || (log.jobName === 'domain-create' && log.progress === 'error')" title="Reinitiate job" data-toggle="tooltip" data-placement="top" data-html="true" :disabled="retryLoader === log.docID" class="btn btn-success btn-sm mr-2" @click="reinitiateCreateDomainJob(log)"><i class="fa fa-repeat"></i></button>
                <div v-if="log.status === 'paused'" :disabled="loader" class="dropdown">
                  <template v-if="log.jobName === 'backup-job'">
                    <button data-toggle="tooltip" data-placement="top" data-html="true" title="Resume this job" class="btn btn-success btn-sm mr-2" type="button" @click="resumeJob(log, true)">
                      <div v-if="loader" class="loader mini_loader"></div>
                      <i v-else class="fa fa-check"></i>
                    </button>
                  </template>
                  <template v-else>
                    <button title="Resume this job" class="btn btn-success btn-sm mr-2 dropdown-toggle" type="button" id="dropdownMenuButton1" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                      <div v-if="loader" class="loader mini_loader"></div>
                      <i v-else class="fa fa-check"></i>
                    </button>
                    <div class="dropdown-menu" aria-labelledby="dropdownMenuButton1">
                      <a class="dropdown-item" @click="resumeJob(log, false)" href="javascript:void(0)">Normal</a>
                      <a class="dropdown-item" @click="resumeJob(log, true)" href="javascript:void(0)">Forced</a>
                    </div>
                  </template>
                </div>
                <button data-toggle="tooltip" data-placement="top" data-html="true" v-if="(log.status === 'running' || (log.status === 'awaiting-hook' || secretEmails.includes(user.email))) && adminRoles.includes(user.userType)" title="Mark as completed" class="btn btn-success btn-sm mr-2" :disabled="loader" @click="completeJob(log)">
                  <div v-if="loader" class="loader mini_loader"></div>
                  <i v-else class="fa fa-check"></i>
                </button>
                <button data-toggle="tooltip" data-placement="top" data-html="true" title="Delete Log" class="btn btn-danger btn-sm mr-2" :disabled="loader || !adminRoles.includes(user.userType)" @click="deleteSingleLog(log)">
                  <div v-if="loader" class="loader mini_loader"></div>
                  <i v-else class="fa fa-times"></i>
                </button>
                <button data-toggle="tooltip" data-placement="top" data-html="true" class="btn btn-primary btn-sm" title="Login as user" @click="loginAsUser(log)">
                  <i class="fa fa-user"></i>
                </button>
              </div>
            </td>
          </tr>
          <tr>
            <td colspan="10">
              <div class="d-flex justify-content-between align-items-center">
                <span class="fw-500 fs-16 mr-10 d-flex align-items-center">
                  Page {{ pageNumber + 1 }} of {{ pageSize }}
                  <span class="ml-30 d-flex align-items-center fw-500">rows per page
                    <div class="form-group mt-10 ml-10">
                      <select class="form-control" v-model="pageSize">
                        <option v-for="(search, index) in rowsPerPage" :selected="search.selected" :value="search.value" v-bind:key="index"> {{ search.value }}</option>
                      </select>
                    </div>
                  </span>
                </span>
                <span>
                  <button type="button" class="btn btn-light" :disabled="pageNumber === 0" @click="prevPage">Previous</button>
                  <button type="button" class="btn btn-light ml-10" :disabled="logs.length < pageSize" @click="nextPage">Next</button>
                </span>
              </div>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
    </div>
    <div class="view-log-modal">
      <div class="modal fade" tabindex="-1" role="dialog" id="viewLogsModal" aria-hidden="true">
        <div class="modal-dialog modal-lg" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h6 class="modal-title">Job: {{selectedLog.docID}}</h6>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <h6>Input data for this job:</h6>
              <code>
                <ol>
                  <li v-for="(value, propertyName) in selectedLog.jobData" :key="propertyName">
                    <template v-if="!uselessJobData.includes(propertyName)">
                      <span>{{propertyName}}</span> : <b>{{value}}</b>
                    </template>
                  </li>
                </ol>
              </code>
              <h6 style="margin-top: 10px">Logs</h6>
              <perfect-scrollbar style="position: relative; max-height: 500px;">
                <code>
                  <ol>
                    <li v-for="(log, index) in selectedLog.logs" :key="'logVal_' + index">
                      <span :class="[(log.type === 'info') ? 'info' : 'danger']">{{log.date | formatDate}}</span> |
                      <span :class="['badge', (log.type === 'info') ? 'badge-success' : 'badge-danger']">{{log.type}}</span> |
                      <span :class="[(log.type === 'info') ? 'info' : 'danger']">
                      <span v-if="log.log.includes('response of bash') || log.log.includes('Response from bashscript')">
                          <span class="font-semibold text-blue-600 mb-0">Bash Response:</span>
                          <pre class="mb-0">
                            {{ formattedBashResponse(log.log) }}
                          </pre>
                        </span>
                      <span v-else-if="log.log.includes('Response from hook')">
                          <span class="font-semibold text-blue-600 mb-0">Json got in hook:</span>
                          <pre class="mb-0">
                            {{ formattedBashResponse(log.log) }}
                          </pre>
                        </span>
                      <span v-else>{{log.log}}</span>
                    </span>
                    </li>
                  </ol>
                </code>
              </perfect-scrollbar>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="advanced-filter-modal">
      <div class="modal fade" id="advancedFilterModal" tabindex="-1" role="dialog" aria-labelledby="advancedFilterModalTitle" aria-hidden="true">
        <div class="modal-lg modal-dialog modal-dialog-centered" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title" id="exampleModalLongTitle">Advanced Filter</h5>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <div class="row">
                <div class="col-md-6">
                  <label class="fw-600">Job Type</label>
                  <select class="form-control" v-model="advancedFilter.jobType">
                    <option value="" disabled selected>Select Job Type</option>
                    <option v-for="(search, index) in jobTypeArray" :value="search.value" v-bind:key="index"> {{ search.name }}</option>
                  </select>
                </div>
                <div class="col-md-6">
                  <label class="fw-600">Search Type</label>
                  <select class="form-control" v-model="advancedFilter.searchType">
                    <option value="" disabled>Select Search Type</option>
                    <option value="Domain">Domain</option>
                    <option value="IP">IP</option>
                    <option value="Email">Client Email</option>
                  </select>
                </div>
                <div v-if="advancedFilter.searchType" class="col-md-6">
                  <label class="fw-600 mt-5">{{ advancedFilter.searchType }}</label>
                  <input type="text" class="form-control" :placeholder="`Enter ${advancedFilter.searchType}`" v-model="advancedFilter.searchQuery">
                </div>
                <div v-if="advancedFilter.searchType" class="col-md-6">
                  <label class="fw-600 mt-5">Initiated By</label>
                  <select class="form-control" v-model="advancedFilter.searchBy">
                    <option value="" disabled selected>Select Initiated By</option>
                    <option v-for="(search, index) in searchByTypeArray" :value="search.value" v-bind:key="index"> {{ search.name }}</option>
                  </select>
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
              <button :disabled="!advancedFilter.jobType || !advancedFilter.searchType" @click="applyFilter()" type="button" class="btn btn-primary">Apply Filter</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {db} from "@/firebase/init";
import swal from 'sweetalert2';
import moment from "moment";
import firebase from 'firebase/app';
import 'firebase/firestore';
import {PerfectScrollbar} from 'vue2-perfect-scrollbar';

export default {
  name: "newJobLogs",
  components: {PerfectScrollbar},
  mounted(){
    this.getRunningJob()
  },
  data() {
    return {
      secretEmails: ['rao@bigscoots.com', 'khan@bigscoots.com', 'justin@bigscoots.com'],
      runningJobs: 0,
      awaitingHookJobs: 0,
      adminRoles: ['admin', 'super-admin'],
      refreshLoader: false,
      retryLoader: false,
      dt: null,
      loader:false,
      loading:false,
      initDataTable: true,
      selectedLog: {},
      logs: [],
      noLogs: false,
      uselessJobData: ['token', 'addonDomainStructure', 'user'],
      searchBy: 'inputDomain',
      searchQuery: '',
      searchType: '',
      pageSize: 10,
      pageNumber: 0,
      rowsPerPageValue: 10,
      rowsPerPage: [
        {key: 10, value: 10, selected: true},
        {key: 30, value: 30, selected: false},
        {key: 50, value: 50, selected: false},
      ],
      advancedFilter: {
        flag: false,
        jobType: '',
        searchType: '',
        searchQuery: '',
        searchBy: 'both'
      },
      searchData: [{
        for: 'status',
        value: 'complete',
        name: 'Completed'
      },{
        for: 'status',
        value: 'stop',
        name: 'Stopped'
      },{
        for: 'status',
        value: 'Pending',
        name: 'Pending'
      },{
        for: 'status',
        value: 'awaiting-hook',
        name: 'Awaiting Hook'
      },{
        for: 'status',
        value: 'paused',
        name: 'Paused'
      },{
        for: 'status',
        value: 'running',
        name: 'Running'
      },{
        for: 'progress',
        value: 'success',
        name: 'Success'
      },{
        for: 'progress',
        value: 'error',
        name: 'Error'
      }],
      jobTypeArray: [
        {value: 'backup-job', name: 'Backup Job'},
        {value: 'cloning', name: 'Cloning'},
        {value: 'cloudFlare-job', name: 'Cloudflare Job'},
        {value: 'domain-create', name: 'Domain Create'},
        {value: 'domain-modify', name: 'Domain Modify'},
        {value: 'download', name: 'Backup Download'},
        {value: 'fresh-word-press', name: 'Fresh WordPress'},
        {value: 'fix-php-my-admin-job', name: 'Fix PhpMyAdmin'},
        {value: 'over-traffic-job', name: 'Traffic Overage'},
        {value: 'remove-domain', name: 'Remove Domain'},
        {value: 'remove-staging', name: 'Remove Staging'},
        {value: 'refresh-storage', name: 'Refresh Storage'},
        {value: 'redirect-job', name: 'Redirect Job'},
        {value: 'sync-staging', name: 'Sync Staging'},
        {value: 'set-php-version', name: 'Set PHP Version'},
        {value: 'staging-job', name: 'Staging Job'},
        {value: 'sync-domain-data', name: 'Sync Domain Data'},
        {value: 'sync-ticket-access', name: 'Sync Ticket Access'},
        {value: 'sync-mediavine-domains', name: 'Sync Mediavine Domains'},
        {value: 'update-ip', name: 'Update IP'},
        {value: 'zabbix-job', name: 'Zabbix Job'},
      ],
      searchByTypeArray:[
        {value: 'collaborator', name: 'Collaborator'},
        {value: 'client', name: 'Client'},
        {value: 'both', name: 'Both'},
      ],
      statusArray:
          [{
            value: 'complete',
            name: 'Completed'
          },{
            value: 'error',
            name: 'Error'
          },{
            value: 'stop',
            name: 'Stopped'
          },{
            value: 'Pending',
            name: 'Pending'
          },{
            value: 'paused',
            name: 'Paused'
          },{
            value: 'running',
            name: 'Running'
          },{
            value: 'awaiting-hook',
            name: 'Awaiting Hook'
          }],
      searchByFilter: [{
        value: 'inputDomain',
        name: 'Domain'
      },{
        value: 'status',
        name: 'Status'
      },{
        value: 'jobLogId',
        name: 'Job ID'
      },{
        value: 'jobType',
        name: 'Job Type'
      },{
        value: 'ip',
        name: 'IP'
      },
      ]
    };
  },
  watch: {
    pageSize() {
      this.fetchJobs()
    },
    searchBy (value) {
      this.refreshLogs(value);
    },
    searchQuery (newValue) {
      this.searchQuery = newValue.replace(/\s/g, '');
    }
  },
  computed: {
    asyncDone() {
      return this.$store.getters["async/state"];
    },
    asyncText() {
      return this.$store.getters["async/text"];
    },
    last () {
      return (this.logs.length > 0) ? this.logs[this.logs.length-1] : null;
    },
    first () {
      return (this.logs.length > 0) ? this.logs[0] : null;
    },
    user() {
      return this.$store.getters.user;
    }
  },
  created () {
    this.fetchJobs();
    this.getAwaitingHookJob()
  },
  updated () {
    if(this.initDataTable){
      console.log('init data tables....');
      /* eslint-disable */
      // this.dt = $("#job-log-datatable").DataTable({
      //     pagingType: "full_numbers",
      //     lengthMenu: [[10, 25, 50, -1], [10, 25, 50, "All"]],
      //     responsive: true,
      //     "destroy": true,
      //     columnDefs: [
      //         { orderable: false, targets: [0,1,2,3,4,5,7,8] }
      //     ],
      //     order: [[6, "desc"]],
      //     language: {
      //         search: "_INPUT_",
      //         searchPlaceholder: "Search records"
      //     }
      // });
      /* eslint-enable */
      this.initDataTable = false;
    }

  },
  methods: {
    formattedBashResponse(log) {
      try {
        if(!log) return ''
        // Extract JSON part from the log message
        const jsonPart = log.split("-> ").slice(1).join("-> ");
        console.log('jsonPart', jsonPart);
        return JSON.stringify(JSON.parse(jsonPart), null, 2).trim();
      } catch (error) {
        return "Invalid JSON format";
      }
    },
    async getRunningJob(){
      const ref = await db.collection('jobLogs')
          .where('status', "==", 'running')
          .orderBy("createdAt", "desc")
          .limit(500)
          .get();
      console.log('ref of size', ref.size)
      this.runningJobs = ref.size;
      console.log('running jobs', this.runningJobs)
    },
    async getAwaitingHookJob(){
      const query = await db.collection('jobLogs')
          .where('status', "==", 'awaiting-hook')
      // this.awaitingHookJobs = query.size;

      this.pendingJobListener =  query.onSnapshot(snapshot => {
        snapshot.docChanges().forEach((change) => {
          if (change.type === 'added') {
            this.awaitingHookJobs += 1
          } else if (change.type === 'removed') {
            this.awaitingHookJobs -= 1
          }
          console.log('running jobs', this.awaitingHookJobs)
        })
      });
    },
    resetAdvancedFilter() {
      this.advancedFilter.flag = false;
      this.advancedFilter.jobType = '';
      this.advancedFilter.searchQuery = '';
      this.advancedFilter.searchType = '',
          this.advancedFilter.searchBy= 'both'
      this.refreshLogs('refresh')
    },
    async applyFilter() {
      this.advancedFilter.flag = true;
      $("#advancedFilterModal").modal("hide");
      await this.fetchJobs()
    },
    openAdvancedFilterModal() {
      /* eslint-disable */
      this.advancedFilter = {
        flag: false,
        jobType: '',
        searchType: '',
        searchBy: 'both'
      }
      $("#advancedFilterModal").modal("show");
      // $(document).ready(function () {
      //   $(".modal-backdrop").removeClass(".advanced-filter-modal");
      // });
      /* eslint-enable */
    },
    formatDate(date) {
      return moment(date).format('DD MMM, YYYY hh:mm a')
    },
    doCopy(item){
      if(item) {
        this.$copyText(item).then(() => {
          this.$notify({
            group: 'foo',
            title: 'Message',
            text: 'Copied!'
          });
        }, function (e) {
          console.log(e)
        });
      }
    },
    loginAsUser (data) {
      console.log(data)
      try {
        this.loader = true;
        if (data.user && data.user.id) {
          window.open(`https://wpo.bigscoots.com/user/dashboard?id=${data.user.id}`,'WPO-Bigscoots');
        }
      } catch (e) {
        console.log(e.toString())
        swal('Error', 'Unable to login to user account!', 'error')
      } finally {
        this.loader = false;
      }
    },
    async retryCheckServer(job) {
      try {
        this.retryLoader = job.docID
        await this.$http.post('/utilities/check-new-servers', {
          docID: job.docID,
          grant_type: 'token'
        })
        swal('Success!', 'Job has been completed.', 'success');
      }catch (e) {
        console.log(e)
        swal('Error!', 'Error in running this job.', 'error');
      }
      this.retryLoader = false
    },
    async reinitiateCreateDomainJob(job) {
      try {
        this.retryLoader = job.docID
        await this.$http.post('/utilities/reinitiate-create-domain-job', {
          jobLogId: job.docID,
          ip: job.jobData.ip,
          grant_type: 'token'
        })
        swal('Success!', 'Job has been reinitiated.', 'success');
      }catch (e) {
        console.log(e)
        swal('Error!', 'Error in running this job.', 'error');
      }
      this.retryLoader = false
    },
    async refreshAccountAccess(log) {
      try {
        this.refreshLoader = true;
        const response = await this.$http.post('/sign-up/refresh-account-access', {
          userEmail: log.jobData.email
        });
        let newLog = {date: new Date().toISOString(), log: 'Email has been sent to the user to refresh account access!', type: 'info'}
        await db.collection('jobLogsActivities').doc(log.docID).update({
          logs: firebase.firestore.FieldValue.arrayUnion(newLog)
        }); // need tp be fixed
        swal('Success!', response.data.message, 'success');
      } catch (e) {
        console.log(e.toString())
        console.log('error', e.response)
        swal('Error!', 'Something went wrong while refreshing account access!', 'error');
      } finally {
        this.refreshLoader = false;
      }
    },
    viewLogs (log) {
      this.selectedLog = log
      try {
        const docRef = db.collection('jobLogsActivities').doc(log.docID);
        docRef.onSnapshot((doc) => {
          if (doc.exists) {
            this.selectedLog.logs = doc.data().logs;
          } else {
            console.log('No such document!');
          }
        }, (error) => {
          console.error('Error getting document:', error);
        });
      } catch (error) {
        console.error('Error setting up snapshot listener:', error);
      }
      /* eslint-disable */
      $("#viewLogsModal").modal("show");
      $(document).ready(function () {
        $(".modal-backdrop").removeClass(".view-log-modal");
      });
      /* eslint-enable */
    },
    refreshLogs (value=null) {
      if(value === 'refresh'){
        console.log(value, 'this value is refresh');
        this.searchQuery = '';
        this.noLogs = false;
        this.pageNumber = 0;
        this.advancedFilter = {
          flag: false, searchQuery: '', jobType: '', searchType: ''
        }
        this.logs = [];
        this.noLogs = false;
        this.loading = true;
        // this.getRunningJob()
        setTimeout(this.fetchJobs, 1000);
      }
      this.searchQuery = '';
    },
    async fetchJobs () {
      /* eslint-disable */
      // if ($.fn.DataTable.isDataTable("#datatable")) {
      //     $('#job-log-datatable').DataTable().destroy();
      // }
      /* eslint-enable */
      this.logs = [];
      this.noLogs = false;
      this.loading = true;
      this.pageNumber = 0;
      let joblogId = false;
      let ref = db.collection('jobLogs');
      let docs = [];
      try {
        if ((this.searchQuery || this.searchBy === 'loginAttempts') && !this.advancedFilter.flag) {
          if (this.searchBy === 'ip') {
            console.log('here')
            docs = await  ref
                .where('jobData.ip', "==", this.searchQuery)
                .orderBy("createdAt", "desc")
                .limit(this.pageSize)
                .get();
          }
          else if (this.searchBy === 'loginAttempts') {
            ref = ref.where('jobName', "==", 'too-many-login-requests')
            if (this.searchQuery) {
              ref = ref.where('jobData.email', "==", this.searchQuery.toLowerCase())
            }
            docs = await  ref
                .orderBy("createdAt", "desc")
                .limit(this.pageSize)
                .get();
          }else if (this.searchBy === 'jobLogId') {
            console.log('inside 626')
            ref = ref.doc(this.searchQuery)
            docs = await  ref
                .get();
            if(docs.exists) {
              this.logs.push({docID: docs.id, ...docs.data()})
              joblogId = true
            }
            console.log('623', docs)
          }
          else if (this.searchBy === 'inputDomain') {
            docs = await  ref
                .where('inputDomain', '>=',  this.searchQuery.trim().toLowerCase())
                .where('inputDomain', '<=', this.searchQuery.trim().toLowerCase() + '\uf8ff')
                .orderBy('inputDomain', 'desc')
                .orderBy('createdAt', 'desc')
                .limit(this.pageSize)
                .get();
          }
          else if(this.searchBy === 'jobType'){
            console.log('query',this.searchBy, this.searchQuery)
            if(this.searchQuery === 'download'){
              docs = await  ref
                  .where('jobData.operation', "==", this.searchQuery)
                  .orderBy("createdAt", "desc")
                  .limit(this.pageSize)
                  .get();
            } else {
              docs = await  ref
                  .where('jobData.jobType', "==", this.searchQuery)
                  .orderBy("createdAt", "desc")
                  .limit(this.pageSize)
                  .get();
            }
          }
          else {
            console.log('query',this.searchBy, this.searchQuery)
            let status = this.searchBy;
            if(this.searchBy === 'status' && this.searchQuery === 'error'){
              status = 'progress'
            }
            docs = await  ref
                .where(status, "==", status !== 'status' ? this.searchQuery.toLowerCase() : this.searchQuery)
                .orderBy("createdAt", "desc")
                .limit(this.pageSize)
                .get();
          }
        } else if(this.advancedFilter.flag) {

          docs = ref
              .where('jobData.jobType', "==", this.advancedFilter.jobType)
          if(this.advancedFilter.searchBy==='client'){
            docs = docs.orderBy('collaborator').where('collaborator', '==', false)
          }
          else if(this.advancedFilter.searchBy === 'collaborator'){
            docs = docs.orderBy('collaborator').where('collaborator', '!=', false)
          }
          if(this.advancedFilter.searchType === 'Domain') {
            docs = docs.where('inputDomain', '==', this.advancedFilter.searchQuery)
          } else if(this.advancedFilter.searchType === 'Email'){
            docs = docs.where('user.email', '==', this.advancedFilter.searchQuery)
          } else if(this.advancedFilter.searchType === 'IP') {
            docs = docs.where('jobData.ip', '==', this.advancedFilter.searchQuery)
          }
          docs = await docs.orderBy("createdAt", "desc")
              .limit(this.pageSize)
              .get();
        } else {
          docs = await ref
              .orderBy("createdAt", "desc")
              .limit(this.pageSize)
              .get()
        }
        console.log('686', docs)
        if(!joblogId) {
          if (docs.empty === true) {
            this.noLogs = true;
          }
          docs.forEach(doc => {
            this.logs.push({
              docID: doc.id,
              ...doc.data()
            })
            console.log('This read', this.logs)
          });
        }
        $(function () {
          $('[data-toggle="tooltip"]').tooltip()
        })
        this.getRunningJob()
      } catch (err) {
        console.error(err);
        // Show error message to the customer for 5 sec
        this.$store.dispatch("alert/update", {
          type: "danger",
          message: err.name,
          show: true
        });
        this.advancedFilter.flag = false;

        setTimeout(() => {
          this.$store.dispatch("alert/showUpdate", {show: false});
        }, 5000);
      }
      $(function () {
        $('[data-toggle="tooltip"]').tooltip()
      })
      this.loading = false;
    },
    deleteLogs () {
      swal({
        title: "Are you sure?",
        text: 'Please confirm that you want flush all background job logging?',
        type: "question",
        confirmButtonText: "Yes Proceed",
        confirmButtonColor: "#6ACF98",
        showCancelButton: true,
        cancelButtonText: "No Thanks",
        cancelButtonColor: "#EE8057"
      })
          .then( result => {
            // Check if the user has clicked YES
            if(result.value) {
              let collectionRef = db.collection("jobLogs");
              collectionRef.get().then(async docs => {
                const batchSize = 500;
                let totalBatches = Math.ceil(docs.size / batchSize);
                let docReferences = [];
                docs.forEach(doc => {
                  docReferences.push(doc.ref);
                });
                for(let b = 0; b < totalBatches; b++) {
                  this.$store.dispatch("async/stateUpdate", {state: false, text: 'Deleting Batch: ' + (b + 1) + '/' + totalBatches});
                  let batch = db.batch();
                  let startIndex = b * batchSize;
                  let endIndex = (((batchSize + startIndex) < docs.size)) ? batchSize + startIndex : docs.size;
                  console.log(startIndex, endIndex);
                  for(let d = startIndex; d < endIndex; d++){
                    batch.delete(docReferences[d]);
                  }
                  await batch.commit();
                }
                this.$store.dispatch("async/stateUpdate", {state: true, text: ''});
                await this.addLog({
                  message: 'User has deleted all job logs.',
                  level: "info"
                })
                this.initDataTable = true;
                this.fetchJobs();
              })
            }
          });
    },
    async deleteSingleLog(log){
      /* eslint-disable */
      try {
        swal({
          title: 'Please Confirm',
          text: `Do you want to delete the job log of ${log.inputDomain} whose Job Id is ${log.docID} and job type is ${log.jobData.jobType}?`,
          type: 'question',
          showCancelButton: true,
          confirmButtonColor: "#6ACF98",
          cancelButtonColor: "#EE8057",
          confirmButtonText: "Yes Proceed",
          cancelButtonText: "No Thanks",
        }).then(async(result) => {
          if(result.value) {
            this.loader = true;
            let res = null;
            if(log.jobName === 'too-many-login-requests') {
              console.log('inside too many login request condition');
              await db.collection('jobLogs').doc(log.docID).delete()
              await db.collection('jobLogsActivities').doc(log.docID).delete()
            } else {
              res = await this.$http.post('/queue/remove_job', {
                jobId: log.docID
              });
              console.log(res.data);
            }
            swal('Deleted!', 'Job has been successfully deleted from background processing queue as well as from firestore database.', 'success');
            this.fetchJobs();
            this.addLog({
              message: 'User has deleted job log, job:' + log.jobName + ', Domain: ' + log.inputDomain,
              level: "info"
            })
          }
        })

      } catch (e) {
        console.error(e.toString());
        swal('Error!', 'Error in removing job.', 'error');
      } finally {
        this.loader = false;
      }

      // this.$http.post('/queue/remove_job', {
      //     jobId: log.docID
      // }).then(res => {
      //     console.log(res.data);
      //     swal('Deleted!', 'Job has been successfully deleted from background processing queue as well as from firestore database.', 'success');
      //     this.fetchJobs();
      //     this.addLog({
      //       message: 'User has deleted job log, job:' + log.jobName + ', Domain: ' + log.inputDomain,
      //       level: "info"
      //     })
      // }).catch(e => {
      //     console.error(e.toString());
      //     swal('Error!', 'Error in removing job.', 'error');
      // }).finally(() => {
      //     this.loader = false;
      // })
      /* eslint-enable */
    },
    async completeJob (job) {
      this.loader = true
      try {
        await this.$http.post('/utilities/complete-job', {
          docID: job.docID,
          jobData: JSON.stringify(job.jobData),
          completedBy: this.user.firstName + ' ' + this.user.lastName,
          grant_type: 'token'
        })
        await this.fetchJobs()
      } catch (e) {
        console.error(e);
        swal('Error!', 'Error in completing the job. Please try again.')
      }
      this.loader = false
    },
    async resumeJob(job, skip) {
      let jobData = job.jobData;
      jobData.skip=skip
      this.loader = true;
      await db.collection('jobLogs').doc(job.docID).update({
        status: 'Pending',
        skip
      });
      this.$http.post('/staging-request/resume-job', {
        jsonData: JSON.stringify(jobData),
        grant_type: 'token'
      }).then(resp => {
        console.log(resp.data);
        if (job.jobName === 'backup-job') {
          swal('Success', `Backup restore job for domain: ${job.inputDomain} has been restored successfully!`, 'success');
        } else {
          swal('Success', resp.data.msg, 'success');
        }
        this.fetchJobs();
        this.addLog({
          message: 'User has resumed job:' + job.jobName + ', Domain: ' + job.inputDomain,
          level: "info"
        })
        this.loader = false;
      }).catch((err) => {
        console.error(err);
        swal('Error!', 'Error in resume the job. Please try again.')
      });
    },
    async nextPage() {
      if (this.last) {
        this.pageNumber ++;
        this.noUser = false;
        this.loading = true;
        this.$store.dispatch("async/stateUpdate", {state: false});
        try {
          let ref = db.collection('jobLogs');
          let docs = [];
          if ((this.searchQuery || this.searchBy === 'loginAttempts') && !this.advancedFilter.flag) {
            if (this.searchBy === 'ip') {
              docs = await  ref
                  .where('jobData.ip', "==", this.searchQuery)
                  .orderBy("createdAt", "desc")
                  .startAfter(this.last.createdAt)
                  .limit(this.pageSize)
                  .get();
            } else if (this.searchBy === 'loginAttempts') {
              ref = ref.where('jobName', "==", 'too-many-login-requests')
              if (this.searchQuery) {
                ref = ref.where('jobData.email', "==", this.searchQuery.toLowerCase())
              }
              docs = await  ref
                  .orderBy("createdAt", "desc")
                  .startAfter(this.last.createdAt)
                  .limit(this.pageSize)
                  .get();
            } else if (this.searchBy === 'inputDomain') {
              docs = await  ref
                  .where('inputDomain', '>=', this.searchQuery.trim().toLowerCase())
                  .where('inputDomain', '<=', this.searchQuery.trim().toLowerCase() + '\uf8ff')
                  .orderBy("inputDomain", "desc")
                  .orderBy("createdAt", "desc")
                  .startAfter(this.last.inputDomain, this.last.createdAt)
                  .limit(this.pageSize)
                  .get();
            }else if(this.searchBy === 'jobType'){
              console.log('query',this.searchBy, this.searchQuery)
              docs = await  ref
                  .where('jobData.jobType', "==", this.searchQuery)
                  .orderBy("createdAt", "desc")
                  .startAfter(this.last.createdAt)
                  .limit(this.pageSize)
                  .get();
            } else {
              docs = await  ref
                  .where(this.searchBy, "==", this.searchBy !== 'status' ? this.searchQuery.toLowerCase() : this.searchQuery)
                  .orderBy("createdAt", "desc")
                  .startAfter(this.last.createdAt)
                  .limit(this.pageSize)
                  .get();
            }
          } else if(this.advancedFilter.flag) {
            docs = ref
                .where('jobData.jobType', "==", this.advancedFilter.jobType)
            if(this.advancedFilter.searchBy==='client'){
              docs = docs.orderBy('collaborator').where('collaborator', '==', false)
            }
            else if(this.advancedFilter.searchBy === 'collaborator'){
              docs = docs.orderBy('collaborator').where('collaborator', '!=', false)
            }
            if(this.advancedFilter.searchType === 'Domain') {
              docs = docs.where('inputDomain', '==', this.advancedFilter.searchQuery)
            } else if(this.advancedFilter.searchType === 'Email'){
              docs = docs.where('user.email', '==', this.advancedFilter.searchQuery)
            } else if(this.advancedFilter.searchType === 'IP') {
              docs = docs.where('jobData.ip', '==', this.advancedFilter.searchQuery)
            }
            docs = await docs.orderBy("createdAt", "desc")
                .limit(this.pageSize)
                .startAfter(this.last.createdAt)
                .get()
          } else {
            docs = await ref
                .orderBy("createdAt", "desc")
                .limit(this.pageSize)
                .startAfter(this.last.createdAt)
                .get()
          }
          if (docs.empty === true) {
            this.noLogs = true;
          }
          this.logs = [];
          docs.forEach(doc => {
            this.logs.push({
              docID: doc.id,
              ...doc.data()
            })
          });
          this.$store.dispatch("async/stateUpdate", {state: true});
        } catch (err) {
          console.error(err);
          // Show error message to the customer for 5 sec
          this.$store.dispatch("alert/update", {
            type: "danger",
            message: err.name,
            show: true
          });
          this.$store.dispatch("async/stateUpdate", {state: true});

          setTimeout(() => {
            this.$store.dispatch("alert/showUpdate", {show: false});
          }, 5000);
        }
        this.loading = false;
      }
    },
    async prevPage(){
      if (this.first) {
        this.pageNumber --;
        this.noUser = false;
        this.loading = true;
        this.$store.dispatch("async/stateUpdate", {state: false});
        try {
          let ref = db.collection('jobLogs');
          let docs = [];
          if ((this.searchQuery || this.searchBy === 'loginAttempts') && !this.advancedFilter.flag) {
            if (this.searchBy === 'ip') {
              docs = await  ref
                  .where('jobData.ip', "==", this.searchQuery)
                  .orderBy("createdAt", "desc")
                  .endBefore(this.first.createdAt)
                  .limitToLast(this.pageSize)
                  .get();
            } else if (this.searchBy === 'loginAttempts') {
              ref = ref.where('jobName', "==", 'too-many-login-requests')
              if (this.searchQuery) {
                ref = ref.where('jobData.email', "==", this.searchQuery.toLowerCase())
              }
              docs = await  ref
                  .orderBy("createdAt", "desc")
                  .endBefore(this.first.createdAt)
                  .limitToLast(this.pageSize)
                  .get();
            } else if (this.searchBy === 'inputDomain'){
              docs = await  ref
                  .where('inputDomain', '>=', this.searchQuery.trim().toLowerCase())
                  .where('inputDomain', '<=', this.searchQuery.trim().toLowerCase() + '\uf8ff')
                  .orderBy('inputDomain', 'desc')
                  .orderBy('createdAt', 'desc')
                  .endBefore(this.first.inputDomain, this.first.createdAt)
                  .limitToLast(this.pageSize)
                  .get();
            } else if(this.searchBy === 'jobType'){
              console.log('query',this.searchBy, this.searchQuery)
              docs = await  ref
                  .where('jobData.jobType', "==", this.searchQuery)
                  .orderBy("createdAt", "desc")
                  .endBefore(this.first.createdAt)
                  .limitToLast(this.pageSize)
                  .get();
            }else {
              docs = await  ref
                  .where(this.searchBy, "==", this.searchBy !== 'status' ? this.searchQuery.toLowerCase() : this.searchQuery)
                  .orderBy("createdAt", "desc")
                  .endBefore(this.first.createdAt)
                  .limitToLast(this.pageSize)
                  .get();
            }
          }else if(this.advancedFilter.flag) {
            docs = ref
                .where('jobData.jobType', "==", this.advancedFilter.jobType)
            if(this.advancedFilter.searchBy==='client'){
              docs = docs.orderBy('collaborator').where('collaborator', '==', false)
            }
            else if(this.advancedFilter.searchBy === 'collaborator'){
              docs = docs.orderBy('collaborator').where('collaborator', '!=', false)
            }
            if(this.advancedFilter.searchType === 'Domain') {
              docs = docs.where('inputDomain', '==', this.advancedFilter.searchQuery)
            } else if(this.advancedFilter.searchType === 'Email'){
              docs = docs.where('user.email', '==', this.advancedFilter.searchQuery)
            } else if(this.advancedFilter.searchType === 'IP') {
              docs = docs.where('jobData.ip', '==', this.advancedFilter.searchQuery)
            }
            docs = await docs.orderBy("createdAt", "desc")
                .endBefore(this.first.createdAt)
                .limitToLast(this.pageSize)
                .get()
          } else {
            docs = await ref
                .orderBy("createdAt", "desc")
                .endBefore(this.first.createdAt)
                .limitToLast(this.pageSize)
                .get()
          }
          if (docs.empty === true) {
            this.noLogs = true;
          }
          this.logs = [];
          docs.forEach(doc => {
            this.logs.push({
              docID: doc.id,
              ...doc.data()
            })
          });
          this.$store.dispatch("async/stateUpdate", {state: true});
        } catch (err) {
          console.error(err);
          // Show error message to the customer for 5 sec
          this.$store.dispatch("alert/update", {
            type: "danger",
            message: err.name,
            show: true
          });
          this.$store.dispatch("async/stateUpdate", {state: true});

          setTimeout(() => {
            this.$store.dispatch("alert/showUpdate", {show: false});
          }, 5000);
        }
        this.loading = false;
      }
    }
  }
}
</script>

<style scoped>
.badge-success {
  background-color: #c6ffea;
  color: #57d364;
  border: none;
}
.badge-warning {
  background-color: #fff5e1;
  color: #e9bb36;
  border: none;
}
.badge-primary {
  background-color: #f3ecff;
  color: #8491ff;
  border: none;
}
.badge-default {
  background-color: #f0f0f0;
  color: #9d98a8;
  border: none;
}
.badge-danger {
  background-color: #feeeee;
  color: #c52727;
  border: none;
}
code {
  background: #f4f4f4;
  border: 1px solid #ddd;
  border-left: 3px solid #2954fa;
  color: #666;
  page-break-inside: avoid;
  font-family: monospace;
  font-size: 12px;
  line-height: 1.6;
  margin-bottom: 1.6em;
  max-width: 100%;
  overflow: auto;
  padding: 1em 1.5em;
  display: block;
  word-wrap: break-word;
}
code .info{
  color: #376c4f;
}
code .danger{
  color: #cf363e;
}
table {
  border-collapse: separate;
  border-spacing: 0;
}

/* top-left border-radius */
table thead th:first-child {
  border-top-left-radius: 8px;
  border-left: 1px solid #dee2e6 !important;
}

/* top-right border-radius */
table thead th:last-child {
  border-top-right-radius: 8px;
  border-right: 1px solid #dee2e6 !important;
}
table thead th:nth-child(even) {
  border-bottom: none !important;
}table thead th:nth-child(odd) {
   border-bottom: none !important;
 }table tr:last-child td:first-child {
    border-top: none !important;
  }

/* bottom-left border-radius */
table tr:last-child td:first-child {
  border-bottom-left-radius: 8px;
}

/* bottom-right border-radius */
table tr:last-child td:last-child {
  border-bottom-right-radius: 8px;
}
.light{
  background-color: #f2f2f2 !important;
}
.btn-light{
  color: black;
  border: 1px solid lightgray;
  border-radius: 4px;
}
</style>

